function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import classnames from 'classnames';
import { isEmpty, map } from 'lodash';
import { flow as flowFP, groupBy as groupByFP } from 'lodash/fp';
import React from 'react';
import AssetIcon from '../../components/icon/common/AssetIcon';
import Activity from '../../components/timeline/Activity';
import { DETAILED_STATUS } from '../../constants/job';
import { ASSET_ICON_MAP, STATUS_COLOR_MAP, STATUS_TEXT_MAP } from '../../constants/product';
import text from '../../text';
import { formatDate, formatTime } from '../../utilities/date';
var JobStatusUpdate = function(props) {
    var activityTitle = props.activityTitle, activityDescription = props.activityDescription, detailedStatuses = props.detailedStatuses, createdDate = props.createdDate, jobId = props.jobId, projectId = props.projectId;
    // We asume that a status activity with not detailed status is by default a 'draft'
    var groupedUpdates = !isEmpty(detailedStatuses) ? flowFP([
        function(result) {
            return map(result, function(value, product) {
                return _object_spread_props(_object_spread({}, value), {
                    product: product
                });
            });
        },
        groupByFP('status')
    ])(detailedStatuses) : [
        'Draft'
    ];
    return map(groupedUpdates, function(products, prodStatus) {
        return /*#__PURE__*/ React.createElement(Activity, {
            key: prodStatus,
            className: "JobStatusUpdate"
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Activity.Icon, {
            iconProps: {
                icon: 'circle',
                className: !isEmpty(detailedStatuses) ? STATUS_COLOR_MAP[prodStatus] : STATUS_COLOR_MAP.Draft
            }
        }), /*#__PURE__*/ React.createElement("div", {
            className: "DetailedStatus w-100"
        }, /*#__PURE__*/ React.createElement(Activity.Card.Header, {
            className: "d-flex flex-column pb-1"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "font-weight--500 font-12 d-flex flex-row justify-content-center"
        }, /*#__PURE__*/ React.createElement(Activity.Card.Type, {
            type: activityTitle
        }), /*#__PURE__*/ React.createElement(Activity.Card.Date, {
            date: formatDate(createdDate),
            time: formatTime(createdDate, 'h:mmaaa')
        }), projectId ? /*#__PURE__*/ React.createElement(Activity.Card.HeaderElement, {
            className: classnames({
                hasPipeSeparator: !!jobId
            }, 'projectId py-0')
        }, text('projectId'), ":", projectId) : null, jobId ? /*#__PURE__*/ React.createElement(Activity.Card.HeaderElement, {
            className: "jobId py-0"
        }, text('orderId'), ":", jobId) : null)), /*#__PURE__*/ React.createElement("div", {
            className: "DetailedStatusContent"
        }, !isEmpty(detailedStatuses) ? map(products, function(param, i) {
            var product = param.product, status = param.status, expectedAt = param.expectedAt;
            return /*#__PURE__*/ React.createElement("div", {
                key: i,
                className: "DetailedStatusContent-Item"
            }, /*#__PURE__*/ React.createElement(AssetIcon, {
                product: ASSET_ICON_MAP[product] || '',
                defaultIcon: "cube"
            }), /*#__PURE__*/ React.createElement("span", null, ASSET_ICON_MAP[product] ? text('productPointCloud3DOrder', {
                productType: product
            }) : product, /*#__PURE__*/ React.createElement("strong", null, " ".concat(STATUS_TEXT_MAP[status])), /*#__PURE__*/ React.createElement("span", null, ' ', expectedAt && status !== DETAILED_STATUS.COMPLETED ? text('expectedAt', {
                eta: formatDate(expectedAt)
            }) : null)));
        }) : activityDescription))));
    });
};
export default JobStatusUpdate;
